import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useW9FormLink() {
  const [loading, setLoading] = useState(true);
  const [w9FormLink, setW9FormLink] = useState();

  useEffect(() => {
    axios
      .get(routes.api.enterprises.w9form_link)
      .then((response) => {
        setW9FormLink(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, w9FormLink };
}
